import { connect } from "@formily/react";

export const Text = connect((props) => {
  return <div>{props.content}</div>;
});
